import React from 'react';
import UI from '../../commons/services/UI';
import { isPremium } from '../../commons/services/Wix';

function UpgradeSection({ onUpgradeClick }) {
  return (
    <div className="upgrade-section">

      <hr className="divider-long" />

      <div className="section-inner">

        <p className="app-description">
          Upgrade App to enjoy awesome additional features
        </p>

        <UI.button
          className="btn-upgrade-banner"
          label="Upgrade Now"
          onClick={onUpgradeClick}
        />

      </div>

    </div>
  );
}

export default function(
  {
    onUpdate,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    onUpgradeClick,
    data
  }
) {
  return (
    <div className="MainTab">
      <img
        className="app-logo"
        src="assets/images/oh_icon.svg"
        width="80"
        height="80"
        alt="app logo"
      />

      <p className="app-description">
        Let visitors know when you’re open and closed with a stylish sign.
      </p>

      <UI.button
        className="btn-confirm-primary"
        label="Set Hours"
        onClick={onPrimaryButtonClick}
      />

      <UI.button
        className="btn-confirm-secondary"
        label="Choose Sign"
        onClick={onSecondaryButtonClick}
      />

      {!isPremium() && <UpgradeSection onUpgradeClick={onUpgradeClick} />}

    </div>
  );
}



// WEBPACK FOOTER //
// ./src/apps/settings/MainTab.jsx